var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3818_68",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3818_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0416 24.7917H18.9583V16.0417H16.0416V24.7917ZM17.5 13.125C17.9132 13.125 18.2595 12.9852 18.539 12.7057C18.8185 12.4262 18.9583 12.0799 18.9583 11.6667C18.9583 11.2535 18.8185 10.9071 18.539 10.6276C18.2595 10.3481 17.9132 10.2083 17.5 10.2083C17.0868 10.2083 16.7404 10.3481 16.4609 10.6276C16.1814 10.9071 16.0416 11.2535 16.0416 11.6667C16.0416 12.0799 16.1814 12.4262 16.4609 12.7057C16.7404 12.9852 17.0868 13.125 17.5 13.125ZM17.5 32.0833C15.4826 32.0833 13.5868 31.7005 11.8125 30.9349C10.0382 30.1693 8.49475 29.1302 7.18225 27.8177C5.86975 26.5052 4.83069 24.9618 4.06506 23.1875C3.29944 21.4132 2.91663 19.5174 2.91663 17.5C2.91663 15.4826 3.29944 13.5868 4.06506 11.8125C4.83069 10.0382 5.86975 8.49479 7.18225 7.18229C8.49475 5.86979 10.0382 4.83073 11.8125 4.06511C13.5868 3.29948 15.4826 2.91667 17.5 2.91667C19.5173 2.91667 21.4132 3.29948 23.1875 4.06511C24.9618 4.83073 26.5052 5.86979 27.8177 7.18229C29.1302 8.49479 30.1692 10.0382 30.9349 11.8125C31.7005 13.5868 32.0833 15.4826 32.0833 17.5C32.0833 19.5174 31.7005 21.4132 30.9349 23.1875C30.1692 24.9618 29.1302 26.5052 27.8177 27.8177C26.5052 29.1302 24.9618 30.1693 23.1875 30.9349C21.4132 31.7005 19.5173 32.0833 17.5 32.0833ZM17.5 29.1667C20.7569 29.1667 23.5156 28.0365 25.776 25.776C28.0364 23.5156 29.1666 20.7569 29.1666 17.5C29.1666 14.2431 28.0364 11.4844 25.776 9.22396C23.5156 6.96354 20.7569 5.83333 17.5 5.83333C14.243 5.83333 11.4843 6.96354 9.22392 9.22396C6.9635 11.4844 5.83329 14.2431 5.83329 17.5C5.83329 20.7569 6.9635 23.5156 9.22392 25.776C11.4843 28.0365 14.243 29.1667 17.5 29.1667Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.10c09a913e74b4e1fd4d5ea27a2ac813.svg";
export { ForwardRef as ReactComponent };